import React from 'react';
import { Slider } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styles from './VideoPlayer.module.scss';

interface RangeSliderProps {
  showRangeSlider: boolean;
  rangeSliderValue: [number, number];
  duration: number;
  onRangeChange: (value: [number, number]) => void;
  onRangeChangeComplete: (value: [number, number]) => void;
  /** When true, handle tooltip shows cancel hint instead of time */
  showEscapeHint?: boolean;
  /** Aralık çubuğunun üzerinde, ortada (handle hizasında) ek kontrol */
  centerOverlay?: React.ReactNode;
  /** Mobil/tablet: aralığı iptal (ESC yerine) */
  onCancel?: () => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  showRangeSlider,
  rangeSliderValue,
  duration,
  onRangeChange,
  onRangeChangeComplete,
  showEscapeHint = false,
  centerOverlay,
  onCancel,
}) => {
  if (!showRangeSlider) return null;

  return (
    <div className={styles.rangeBarContainer}>
      <div className={styles.rangeBarTrackWrap}>
        <Slider
          range
          min={0}
          max={duration}
          step={0.01}
          className={styles.rangeSlider}
          value={rangeSliderValue}
          onChange={(value) => {
            if (Array.isArray(value) && value.length === 2) {
              onRangeChange([value[0], value[1]]);
            }
          }}
          onChangeComplete={(value) => {
            if (Array.isArray(value) && value.length === 2) {
              onRangeChangeComplete([value[0], value[1]]);
            }
          }}
        tooltip={{
          placement: 'top',
          autoAdjustOverflow: false,
          formatter: showEscapeHint ? () => 'ESC to cancel' : (v) => `${v?.toFixed(2)}s`,
        }}
          style={{ width: '100%' }}
          trackStyle={[{ background: 'var(--app-accent-color)', height: 2 }]}
          handleStyle={[{}, {}]}
          railStyle={{ background: 'transparent', height: 2 }}
        />
        {centerOverlay}
      </div>
      {onCancel ? (
        <button
          type="button"
          className={`${styles.rangeLoopCancelBtn} ${styles.rangeLoopCancelBtnOnBar}`}
          onClick={(e) => {
            e.stopPropagation();
            onCancel();
          }}
          aria-label="Aralığı iptal et"
          title="Aralığı iptal et"
        >
          <CloseOutlined />
        </button>
      ) : null}
    </div>
  );
};

export default RangeSlider;
